export default "__VITE_ASSET__cPjpA1hS__"